/**
 * Stap 0: welkom, de stelling van vandaag, en wat er gaat gebeuren.
 */
import React from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

export function Welkom({ session, onStart }) {
  return (
    <div style={styles.card}>
      <div style={styles.welcomeHeader}>
        <h1>Welkom bij Socrates!</h1>
        <p style={styles.subtitle}>Leren argumenteren</p>
      </div>

      <div style={styles.stellingCard}>
        <h3 style={styles.stellingLabel}>De stelling van vandaag:</h3>
        <p style={styles.stellingTekst}>{session.statement?.titel}</p>
      </div>

      <div style={styles.infoBox}>
        <div style={styles.infoItem}><span>•</span><span>Je gaat discussiëren met {session.aantal_personas} personen</span></div>
        <div style={styles.infoItem}><span>•</span><span>Socrates staat klaar voor vragen over de discussie</span></div>
        <div style={styles.infoItem}><span>•</span><span>Verzamel argumenten VOOR en TEGEN de stelling</span></div>
      </div>

      <button onClick={onStart} style={styles.startBtn}>Start de discussie</button>
    </div>
  );
}

const styles = {
  ...basis,
  welcomeHeader: { textAlign: 'center', marginBottom: '32px' },
  subtitle: { color: kleur.stil },
  infoBox: { display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' },
  infoItem: { display: 'flex', alignItems: 'center', gap: '12px', fontSize: '15px', color: kleur.tekstZacht },
  startBtn: { width: 'auto', padding: '16px 48px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '12px', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer', display: 'block', margin: '0 auto' },
};
